import { TabPermission } from 'src/app/core/interfaces/permissions';
import { PermissionsC } from 'src/permissions/helpers/permissions.class';
import { Mobile } from '../../../mobile.setup';

const parent = Mobile.pages.simAndLineManagement;
const path = 'sim-management';
const title = 'PAGE.MOBILE.SIM_AND_LINE_MANAGEMENT.SIM.TITLE';
const res = [
  'createLines',
  'actions',
  'actions.bulkActions',
  'actions.simMetadata',
  'actions.endUserInfo',
  'actions.swapSim',
  'actions.lineInfo',
  'actions.copyLineId',
];

export const MobileSimAndLineManagementSimTab: TabPermission =
  PermissionsC.generateTabPermission(parent, path, title, res);
